import { useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { zIndices } from '../../../constants/z-indices';

const SideDrawerOverlay = () => {
  const activeDrawer = useSelector(
    (state: RootState) => state.global.openDrawer
  );

  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const overlayElement = overlayRef.current;
    if (!activeDrawer || overlayElement === null) return;

    const handleTouch = (event: TouchEvent) => {
      event.preventDefault();
    };

    overlayElement.addEventListener('touchstart', handleTouch, {
      passive: false,
    });

    return () => {
      overlayElement.removeEventListener('touchstart', handleTouch);
    };
  }, [activeDrawer]);

  return (
    <div
      ref={overlayRef}
      css={css`
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: ${zIndices.SIDE_DRAWER_OVERLAYS};
        cursor: pointer;
        transition: opacity 150ms ease-in-out;
        opacity: 0;
        pointer-events: none;
        ${activeDrawer &&
        css`
          opacity: 1;
          pointer-events: all;
        `}
      `}
    />
  );
};

export default SideDrawerOverlay;
